
import SvgStarFilled from '@/assets/svg/star-filled.svg?inline'
import SvgStarEmpty from '@/assets/svg/star-empty.svg?inline'
export default {
  components: { SvgStarFilled, SvgStarEmpty },
  props: {
    score: {
      type: String,
      required: true,
    },
    editable: {
      type: Boolean,
      required: false,
      default: false,
    },
    sm: {
      type: Boolean,
      required: false,
      default: false,
    },
    md: {
      type: Boolean,
      required: false,
      default: false,
    },
    lg: {
      type: Boolean,
      required: false,
      default: false,
    },
    xl: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      ratingScore: +this.score,
    }
  },
  methods: {
    setRating(index) {
      this.ratingScore = index + 1
      this.$emit('input', this.ratingScore)
    },
  },
}
